export const _YQ_RC_ = '_yq_rc_'

export const TRACK_LIMIT_AMOUNT = 40 // 最大追踪数，匿名40，免费会员40，基础会员100，高级会员200
